if (!customElements.get("product-details-tab")) {
  class ProductDetailsTab extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.tabContents = this.querySelectorAll(".product-details-tab__content");
      this.tabs = this.querySelectorAll(".product-details-tab__tab");
      this.images = this.querySelectorAll('.product-details-tab__image-inner')

      this.initTabs();
    }

    initTabs() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => {
          this.tabs.forEach((tab) => tab.classList.remove("is-active"));
          tab.classList.add("is-active");

          this.tabContents.forEach((content) =>
            content.classList.remove("is-active")
          );

          this.images.forEach((image) => image.classList.remove("is-active"))
          this.tabContents[index].classList.add("is-active");
          this.images[index].classList.add("is-active")
        });
      });
    }
  }
  customElements.define("product-details-tab", ProductDetailsTab);
}